export const invalidEmailFormatMessage = 'Invalid email format';
export const passwordsDoNotMatchMessage = 'Passwords do not match';
export const passwordResetSuccessMessage = 'Password reset successfully';
export const passwordResetErrorMessage = 'Error resetting password';
export const passwordResetErrorGenericMessage = 'An error occurred during password reset';

export const API_URLS = {
  RESET_PASSWORD: `${process.env.REACT_APP_API_BASE_URL}/reset-password`,
};

export const ResetPassword = "Reset Password";
